/*
 * View for attributes
 */

define(["marionette", "./template/attributesTemplate.html"], function (
  Marionette,
  AttributesTemplate,
) {
  var AttributesView = {};

  AttributesView.attributesLayout = Marionette.Layout.extend({
    template: AttributesTemplate,
    regions: {
      attributeList: "#attributeList",
      attributeValue: "#attributeValue",
    },
  });

  return AttributesView;
});
